/* eslint-disable no-unused-vars */
import * as AspNetData from "devextreme-aspnet-data-nojquery";
import appConfig from "../../../app-config";
import { TokenStorage } from "../../storage";

const CustomerTransactionService = {
  async getByCustomerCode(customerCode) {
    const store = AspNetData.createStore({
      key: "RecordId",
      loadUrl: `${appConfig.VUE_APP_ROOT_API}/apiv2/CustomerTransactionHistory`,
      onBeforeSend: function (method, request) {
        request.headers = {
          Authorization: `Bearer ${TokenStorage.getToken()}`,
          "Content-Type": "application/json",
          "x-tenant-id": TokenStorage.getTenant(),
        };
      },
    });

    return store.load({
      filter: ["CustomerCode", "=", customerCode],
      sort: [{ selector: "DateCreated", desc: true }],
    });
  },
};

export { CustomerTransactionService };
